/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./detailsPageField.vue?vue&type=template&id=06f68d76&scoped=true"
import script from "./detailsPageField.vue?vue&type=script&lang=js"
export * from "./detailsPageField.vue?vue&type=script&lang=js"
import style0 from "./detailsPageField.vue?vue&type=style&index=0&id=06f68d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f68d76",
  null
  
)

export default component.exports